import { type AxiosInstance, type AxiosRequestConfig } from 'axios';
import type { Fetcher, FetcherOptions } from '../types';

/**
 * Wrap an Axios instance to match the Fetcher interface
 */
export default function wrap(axios: AxiosInstance): Fetcher {
  return (url: string, options?: FetcherOptions) => {
    const requestConfig: AxiosRequestConfig = {
      ...options,
      data: options?.body
    };

    return axios(url, requestConfig).then(res => res.data);
  };
}
